import { Observable } from 'rxjs';
import { FileUploadResponse } from '../../../model/laboratory/file/file-upload-response.model';

/**
 * File Upload Repository Interface
 *
 * Defines the contract for file upload operations in the laboratory module.
 * This interface follows the Repository pattern from Domain-Driven Design.
 *
 * Architecture Layer: Domain Service
 * - Defines the contract that infrastructure adapters must implement
 * - Ensures decoupling between domain logic and infrastructure details
 */
export abstract class FileUploadRepository {
  /**
   * Upload a file to the backend for processing
   *
   * @param file - The file to upload
   * @returns Observable with the upload response containing processing results
   */
  abstract uploadFile(file: File): Observable<FileUploadResponse>;
}
